import { render } from "./StudentListTableRow.vue?vue&type=template&id=627853c2&ts=true"
import script from "./StudentListTableRow.vue?vue&type=script&lang=ts"
export * from "./StudentListTableRow.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__